export const INITIAL_POWERS = {
    min: 9999999,
    max: 0
};
